import { Box } from '@factorialco/deprecated-design-system'
import { FullTrainingFragment } from 'generated/resources/graphql'

import Callout from 'modules/core/components/Callout'
import i18n from 'modules/core/lib/i18n'

import type { TrainingsTrainingClass } from 'modules/trainings/pages/Trainings/Revamp/TrainingDetail/Detail/types'

import { Datatable } from './datatable'
import { Fields } from './group-fields'
import { GroupSelector } from './group-selector'

export function Content({
  classes,
  training,
  selectedClassId,
  setSelectedClassId,
  validate,
}: {
  classes: TrainingsTrainingClass[]
  training: FullTrainingFragment
  selectedClassId: number
  setSelectedClassId: (value: number) => void
  validate: boolean
}) {
  const trainingClass = classes.find((x) => x.id === String(selectedClassId))
  return (
    <Box gap="s32">
      <GroupSelector
        classes={classes}
        selectedClassId={selectedClassId}
        setSelectedClassId={setSelectedClassId}
      />
      {trainingClass && (
        <>
          <Callout
            type="info"
            description={i18n.t('trainings.trainings_detail.fundae.editing_callout')}
          />
          <Fields validate={validate} training={training} trainingClass={trainingClass} />
          <Datatable trainingClass={trainingClass} validate={validate} />
        </>
      )}
    </Box>
  )
}
